import React from 'react'
import PropTypes from 'prop-types'

import Dropdown from 'Pods/Shared/Dropdown'
import Icon from 'Pods/Shared/Icon/Icon'

class OpenTemplateAction extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      templates: props.templates,
    }

    this.deleteTemplate = this.deleteTemplate.bind(this)
    this.onDeleteTemplateSuccess = this.onDeleteTemplateSuccess.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.templates !== this.props.templates) {
      this.setState({ templates: this.props.templates })
    }
  }

  deleteTemplate(e, templateId) {
    e.stopPropagation()

    axios.delete(`/api/internal/item-templates/${templateId}`)
      .then(() => this.onDeleteTemplateSuccess(templateId))
      .catch(() => App.events.publish('app:notification:flash:error', 'Template could not be deleted.'))
  }

  onDeleteTemplateSuccess(templateId) {
    const newTemplates = this.state.templates.filter(template => template.id !== templateId)

    App.events.publish('app:notification:flash:success', 'Template successfully removed')
    this.setState({ templates: newTemplates })

    this.props.updateTemplates(newTemplates)
  }

  render() {
    return (
      <span className="template-actions__open-template u-ml10">
        <Dropdown
          title={this.props.activeTemplateName === '' ? 'Load saved template' : this.props.activeTemplateName}
        >
          {this.state.templates.length > 0 ? (
            this.state.templates.map(template => (
              <div
                className={`template-list-item ${this.props.activeTemplateId === template.id ? 'is-active' : ''}`}
                key={template.id}
                onClick={() => this.props.openTemplate(template)}
              >
                <span className="template-title">{template.attributes.name}</span>
                <span className="delete-icon" onClick={(e) => this.deleteTemplate(e, template.id)}>
                  <Icon type={['far', 'times']} className="ml-5" />
                </span>
              </div>
            ))
          ) : (
            <div className="text-light-grey u-ml10"><i>You have no saved templates</i></div>
          )}
        </Dropdown>
      </span>
    )
  }
}

OpenTemplateAction.propTypes = {
  updateTemplates: PropTypes.func.isRequired,
  openTemplate: PropTypes.func.isRequired,
  activeTemplateId: PropTypes.string.isRequired,
  activeTemplateName: PropTypes.string.isRequired,
  templates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      attributes: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    })
  ).isRequired,
}

export default OpenTemplateAction
